<template>
  <div
      class="epoch"
      :id="`epoch-id-${epoch.id}`"
      :data-epoch-id="epoch.id"
  >
    <div class="epoch__text">
      <h2 data-initalfontsize="36">
        {{ epoch.epochYearName }}
      </h2>
    </div>

    <div class="epoch__toggle-btn-wrapper">
      <button
          class="epoch__toggle-btn btn btn--white-bg-on-hover"
          type="button"
          @click="onToggleEpoch"
          aria-pressed="false"
          :aria-label="`${ translations.show } / ${ translations.close } ${epoch.epochYearName}`"
      >
        {{ translations.show }}
      </button>
    </div>

    <div class="epoch__content">
      <MomentVRAK
          v-for="moment in epoch.timelineMapItems"
          :key="moment.urlSegment ?? moment.id"
          :moment="moment"
          :epoch-id="epoch.id"
          :translations="translations"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { IEpoch } from "@features/Pages/TimelineMapPage/_js/app/interfaces/IEpoch";
import type { ITranslations } from "@features/Pages/TimelineMapPage/_js/app/interfaces/ITranslations";
import MomentVRAK from "../moment/MomentVRAK.vue";

const props = defineProps<{
  epoch: IEpoch;
  translations: ITranslations;
}>();

const emit = defineEmits<{
  (e: "toggle-epoch", payload: { epoch: IEpoch; event: MouseEvent }): void;
}>();

function onToggleEpoch(event: MouseEvent) {
  emit("toggle-epoch", { epoch: props.epoch, event });
}
</script>